export function NOOP() {}
export const CATCH_ERROR = (error: Error) => (globalThis as any).Sentry?.captureException(error);

export const EMPTY_OBJECT = Object.freeze<any>({});
export const EMPTY_ARRAY = Object.freeze<any>([]);
export const EMPTY_SET = Object.freeze(new Set<any>());
